import React from 'react';
import { motion } from 'framer-motion';
export function TeamSection() {
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-66">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-electric-violet/5 to-transparent pointer-events-none" data-id="element-67" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} className="mb-12" data-id="element-69">
          {/* Enhanced Team Visual - Glowing Network */}
          <div className="relative w-full h-[300px] flex items-center justify-center overflow-hidden" data-id="element-70">
            <svg className="w-full h-full" viewBox="0 0 800 300" data-id="element-71">
              <defs data-id="element-72">
                <radialGradient id="nodeGlow" cx="50%" cy="50%" r="50%" data-id="element-73">
                  <stop offset="0%" stopColor="#00D9FF" stopOpacity="0.8" data-id="element-74" />
                  <stop offset="100%" stopColor="#8B5CF6" stopOpacity="0" data-id="element-75" />
                </radialGradient>
              </defs>

              {/* Connecting Lines */}
              {[...Array(30)].map((_, i) => <motion.line key={`line-${i}`} x1={100 + i % 6 * 120} y1={80 + Math.floor(i / 6) * 60} x2={220 + i % 6 * 120} y2={80 + Math.floor(i / 6) * 60} stroke="url(#nodeGlow)" strokeWidth="1" opacity="0.3" initial={{
              pathLength: 0
            }} whileInView={{
              pathLength: 1
            }} transition={{
              duration: 2,
              delay: i * 0.05
            }} data-id="element-76" />)}

              {/* Glowing Nodes */}
              {[...Array(25)].map((_, i) => <motion.circle key={`node-${i}`} cx={100 + i % 5 * 150 + Math.random() * 40} cy={80 + Math.floor(i / 5) * 60 + Math.random() * 20} r="4" fill={i % 2 === 0 ? '#00D9FF' : '#8B5CF6'} initial={{
              scale: 0,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} transition={{
              duration: 0.5,
              delay: i * 0.03
            }} animate={{
              scale: [1, 1.5, 1],
              opacity: [0.5, 1, 0.5]
            }} style={{
              filter: `drop-shadow(0 0 8px ${i % 2 === 0 ? '#00D9FF' : '#8B5CF6'})`
            }} data-id="element-77" />)}
            </svg>
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-78">
          Birlikte{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-electric-violet" data-id="element-79">
            Hayal Ediyor
          </span>
          <br data-id="element-80" />
          Birlikte Üretiyoruz.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl text-gray-400 leading-relaxed max-w-2xl mx-auto" data-id="element-81">
          Mühendisler ve hayalperestlerden oluşan multidisipliner bir ekip,
          imkansızı inşa etmek için birleşti. Teknik mükemmelliği yaratıcı
          vizyonla birleştiriyoruz.
        </motion.p>
      </div>
    </section>;
}